var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRecent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12 2a10 10 0 1 0 10 10A10.01 10.01 0 0 0 12 2m4.539 14.777a.69.69 0 0 1-1.01 0l-4.034-4.034a.71.71 0 0 1-.21-.505V5.571a.715.715 0 0 1 1.43 0v6.371l3.824 3.825a.707.707 0 0 1 0 1.01"
})));
export default SvgRecent;